import { Typography } from "@/components";
import { isAuthenticating } from "@/libraries/helper";
import { AuthWebviewSchema } from "@/schemas";
import Check from "@mui/icons-material/Check";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";

export const Route = createFileRoute("/delete-account-success")({
	validateSearch: zodSearchValidator(AuthWebviewSchema),
	beforeLoad: async () => {
		if (!isAuthenticating()) {
			throw redirect({
				to: "/",
				replace: true,
			});
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="wrapper !p-0 h-full">
			<div className="h-full container md:max-w-[400px]">
				<Stack
					spacing={4}
					justifyContent="center"
					alignItems="center"
					className="h-full"
				>
					<div className="flex-none w-fit rounded-2xl bg-green-100 p-4">
						<Check color="success" className="!text-5xl" />
					</div>
					<Typography fontWeight={600} fontSize={24} textAlign="center">
						Account deleted
					</Typography>
					<Typography fontWeight={400} fontSize={16} textAlign="center">
						Your account has been permanently deleted. Thanks for using
						HEMI Teams!
					</Typography>
					<Link to="/">
						<Button
							color="primary"
							variant="contained"
							size="large"
							className="uppercase !rounded-full"
						>
							back to login
						</Button>
					</Link>
				</Stack>
			</div>
		</div>
	);
}
